export const isEmpty = (str: string) => {
  if (!str) return true;
  if (str === '没有' || str.includes('：没有')) return true;
  for (const key of [
    '未披露',
    '未发现',
    '未公开',
    '信息缺失',
    '未涉及',
    '无法识别',
    '无法判断',
    '披露较少',
    '公开信息未提及',
    '缺乏公开信息',
    '公开信息中缺乏',
    '信息受限',
    '信息有限',
    '公开信息未明确',
    '公开信息不足',
  ]) {
    if (str.includes(key)) {
      return true;
    }
  }
  if (str.includes('缺乏') && str.includes('依据')) {
    return true;
  }
  if (/未[^。！？；]*?披露/g.test(str)) {
    return true;
  }
  if (/信息披露[^。！？；]*?有限/g.test(str)) {
    return true;
  }
  return /判断[^。！？；]*?不确定/g.test(str);
};

export const convertToStrList = (
  items: Record<any, any>[] = [],
  keys: string[],
  symbol = '：',
  noEmpty = true,
) => {
  const ret = [];
  for (const item of items) {
    const strs = [];
    for (const key of keys) {
      if (noEmpty) {
        const empty = isEmpty(item[key]);
        if (empty) {
          break;
        }
        strs.push(item[key]);
      } else {
        strs.push(item[key]);
      }
    }
    if (strs.length > 0) {
      ret.push(strs.join(symbol));
    }
  }
  return ret;
};

export const isNoEmptyArray = (obj: any) =>
  Array.isArray(obj) && obj.length > 0;

export const filterArrayWithValidItems = (obj: any): string[] => {
  if (!isNoEmptyArray(obj)) return [];
  return obj.filter((item: string) => !isEmpty(item));
};

export const isObjWithValidEntries = (obj: any) => {
  if (typeof obj !== 'object' || obj === null) {
    return false;
  }
  for (const key of Object.keys(obj)) {
    if (!isEmpty(obj[key])) {
      return true;
    }
  }
  return false;
};
